'use client'

import { Spinner } from '@/components/extension/spinner'
import { ProductFormatted } from '@/types/product'
import {
  ProductCardProvider,
  useProductCardContext,
} from './context/product-card-context'
import { GiftExchangeButton } from './gift-exchange-button'
import { ProductItemInfo } from './product-item-info'
import { ProductItemThumbnail } from './product-item-thumbnail'

type Props = {
  product: ProductFormatted
  gaTrackingValue?: string
  gaTrackingLabel?: string
}

const GiftShopProductCardContent = ({
  gaTrackingValue,
  gaTrackingLabel,
}: {
  gaTrackingValue?: string
  gaTrackingLabel?: string
}) => {
  const { isPendingAddToCart } = useProductCardContext()

  return (
    <div className='relative w-full shrink-0 grow-0'>
      {isPendingAddToCart ? (
        <div
          className='absolute inset-0 z-10 flex items-center justify-center bg-neutral-100/50'
          role='status'
          aria-label='Exchanging gift'
        >
          <Spinner size='large' />
        </div>
      ) : null}
      <figure
        className='flex h-full flex-col space-y-3'
        role='group'
        aria-label='Gift product card'
      >
        <ProductItemThumbnail
          gaTrackingValue={gaTrackingValue}
          gaTrackingLabel={gaTrackingLabel}
          disableNavigation={true}
          hideSizes={true}
        />
        <ProductItemInfo
          gaTrackingValue={gaTrackingValue}
          gaTrackingLabel={gaTrackingLabel}
          disableNavigation={true}
        />
        <GiftExchangeButton />
      </figure>
    </div>
  )
}

export const GiftShopProductCard = ({
  product,
  gaTrackingValue,
  gaTrackingLabel,
}: Props) => {
  return (
    <ProductCardProvider product={product}>
      <GiftShopProductCardContent
        gaTrackingValue={gaTrackingValue}
        gaTrackingLabel={gaTrackingLabel}
      />
    </ProductCardProvider>
  )
}
